import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const KEY = "capdistrib_consent";

export default function CookieBanner() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        try {
            const c = localStorage.getItem(KEY);
            if (!c) setOpen(true);
        } catch (_) {
            /* noop */
        }
    }, []);

    const decide = (value) => {
        try {
            localStorage.setItem(KEY, value);
            if (typeof window !== "undefined" && window.posthog) {
                if (value === "accepted") {
                    window.posthog.opt_in_capturing?.();
                } else {
                    window.posthog.opt_out_capturing?.();
                }
            }
        } catch (_) {
            /* noop */
        }
        setOpen(false);
    };

    if (!open) return null;

    return (
        <div
            className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60]"
            data-testid="cookie-banner"
            role="dialog"
            aria-live="polite"
            aria-label="Bandeau de consentement cookies"
        >
            <div className="relative rounded-2xl bg-cap-ink text-white border border-white/10 shadow-[0_20px_60px_-20px_rgba(108,71,255,0.5)] p-5">
                <button
                    onClick={() => decide("declined")}
                    className="absolute top-3 right-3 text-white/40 hover:text-white"
                    aria-label="Refuser et fermer"
                    data-testid="cookie-close"
                >
                    <X size={16} />
                </button>
                <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-cap-violet/15 ring-1 ring-cap-violet/30 flex items-center justify-center flex-shrink-0">
                        <Cookie className="text-cap-violetSoft" size={18} />
                    </div>
                    <div className="min-w-0">
                        <h3 className="h-display text-[15px] font-semibold">
                            Cookies & confidentialité
                        </h3>
                        <p className="mt-1.5 text-[13px] text-white/65 leading-relaxed">
                            On utilise des cookies de mesure d'audience pour
                            comprendre comment tu navigues sur le site. Aucune
                            donnée n'est collectée sans ton accord.{" "}
                            <a
                                href="/confidentialite"
                                className="underline text-cap-violetSoft hover:text-white"
                            >
                                En savoir plus
                            </a>
                            .
                        </p>
                        <div className="mt-4 flex flex-wrap gap-2">
                            <button
                                onClick={() => decide("accepted")}
                                className="btn-gold px-4 py-2 rounded-full text-[13px]"
                                data-testid="cookie-accept"
                            >
                                Tout accepter
                            </button>
                            <button
                                onClick={() => decide("declined")}
                                className="px-4 py-2 rounded-full text-[13px] font-medium border border-white/15 text-white/85 hover:bg-white/5"
                                data-testid="cookie-decline"
                            >
                                Refuser
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
